var map = {
	"./assistant_1.png": 59195,
	"./assistant_2.png": 61632,
	"./comparator_1.png": 5671,
	"./comparator_2.png": 38636,
	"./heatmap_1.png": 87023,
	"./heatmap_2.png": 68116,
	"./history_1.png": 96883,
	"./history_2.png": 22392,
	"./learning_1.png": 76409,
	"./learning_2.png": 36674,
	"./manager_1.png": 72430,
	"./manager_2.png": 261,
	"./nps_1.png": 96422,
	"./nps_2.png": 37661,
	"./report_1.png": 96985,
	"./report_2.png": 48802,
	"./rps_1.png": 82890,
	"./rps_2.png": 97121,
	"./settings_1.png": 17048,
	"./settings_2.png": 62803,
	"./survey_1.png": 17805,
	"./survey_2.png": 86038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97785;